import { useEffect, useMemo, useState } from "react";
import { shuffle, speak } from "@/lib/speech";

export const MatchExercise = ({ ex, lang, onSubmit }) => {
  const lefts = useMemo(() => shuffle(ex.pairs.map((p) => p.left)), [ex]);
  const rights = useMemo(() => shuffle(ex.pairs.map((p) => p.right)), [ex]);
  const [sel, setSel] = useState(null);
  const [matched, setMatched] = useState([]);
  const [wrong, setWrong] = useState(null);
  const [mistakes, setMistakes] = useState(0);

  useEffect(() => { setSel(null); setMatched([]); setMistakes(0); }, [ex]);

  const pickRight = (r) => {
    if (!sel || matched.includes(sel)) return;
    const pair = ex.pairs.find((p) => p.left === sel);
    if (pair.right === r) {
      const next = [...matched, sel];
      setMatched(next);
      setSel(null);
      if (next.length === ex.pairs.length) setTimeout(() => onSubmit(mistakes <= 1, `${mistakes} mistake(s)`), 350);
    } else {
      setMistakes((m) => m + 1);
      setWrong(r);
      setTimeout(() => setWrong(null), 500);
    }
  };
  const doneRight = (r) => ex.pairs.some((p) => p.right === r && matched.includes(p.left));

  return (
    <div className="grid grid-cols-2 gap-3">
      <div className="flex flex-col gap-3">
        {lefts.map((l, i) => (
          <button
            key={l}
            data-testid={`match-left-${i}`}
            disabled={matched.includes(l)}
            onClick={() => { setSel(l); speak(l, lang); }}
            className={`option-card justify-center ${matched.includes(l) ? "opt-correct opacity-70" : sel === l ? "opt-selected" : ""}`}
          >{l}</button>
        ))}
      </div>
      <div className="flex flex-col gap-3">
        {rights.map((r, i) => (
          <button
            key={r}
            data-testid={`match-right-${i}`}
            disabled={doneRight(r)}
            onClick={() => pickRight(r)}
            className={`option-card justify-center ${doneRight(r) ? "opt-correct opacity-70" : wrong === r ? "opt-wrong animate-shake" : ""}`}
          >{r}</button>
        ))}
      </div>
    </div>
  );
};
